import { render, staticRenderFns } from "./WorkflowCard.vue?vue&type=template&id=412a741e&scoped=true"
import script from "./WorkflowCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowCard.vue?vue&type=style&index=0&id=412a741e&prod&lang=scss"
import style1 from "./WorkflowCard.vue?vue&type=style&index=1&id=412a741e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a741e",
  null
  
)

export default component.exports